var CryptoJS = require('../../node_modules/crypto-js')
/**
 * 获取本周、本季度、本月、上月的开始日期、结束日期
 */
var now = new Date() // 当前日期
var nowDayOfWeek = now.getDay() // 今天本周的第几天
if (nowDayOfWeek === 0) nowDayOfWeek = 7
var nowDay = now.getDate() // 当前日
var nowMonth = now.getMonth() // 当前月
var nowYear = now.getYear() // 当前年
nowYear += (nowYear < 2000) ? 1900 : 0 //
var lastMonthDate = new Date() // 上月日期
lastMonthDate.setDate(1)
lastMonthDate.setMonth(lastMonthDate.getMonth() - 1)
// var lastYear = lastMonthDate.getYear()
var lastMonth = lastMonthDate.getMonth()
// 格式化日期：yyyy-MM-dd
function formatNow(date) {
	var myyear = date.getFullYear()
	var mymonth = date.getMonth() + 1
	var myweekday = date.getDate()
	if (mymonth < 10) {
		mymonth = '0' + mymonth
	}
	if (myweekday < 10) {
		myweekday = '0' + myweekday
	}
	var h = date.getHours()
	h = h < 10 ? ('0' + h) : h
	var minute = date.getMinutes()
	minute = minute < 10 ? ('0' + minute) : minute
	var second = date.getSeconds()
	second = second < 10 ? ('0' + second) : second
	return (myyear + '-' + mymonth + '-' + myweekday + ' ' + h + ':' + minute + ':' + second)
}

function formatDate(date) {
	var myyear = date.getFullYear()
	var mymonth = date.getMonth() + 1
	var myweekday = date.getDate()
	if (mymonth < 10) {
		mymonth = '0' + mymonth
	}
	if (myweekday < 10) {
		myweekday = '0' + myweekday
	}
	return (myyear + '-' + mymonth + '-' + myweekday)
}

// 获得某月的天数
function getMonthDays(myMonth) {
	var monthStartDate = new Date(nowYear, myMonth, 1)
	var monthEndDate = new Date(nowYear, myMonth + 1, 1)
	var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24)
	return days
}
// 获得本季度的开始月份
function getQuarterStartMonth() {
	var quarterStartMonth = 0
	if (nowMonth < 3) {
		quarterStartMonth = 0
	}
	if (nowMonth > 2 && nowMonth < 6) {
		quarterStartMonth = 3
	}
	if (nowMonth > 5 && nowMonth < 9) {
		quarterStartMonth = 6
	}
	if (nowMonth > 8) {
		quarterStartMonth = 9
	}
	return quarterStartMonth
}


function strtodate(str) {
	var year=str.substr(0,4);
	var month=str.substr(5,2);
	var day=str.substr(8,2);
	var hour=str.substr(11,2);
	var minute=str.substr(14,2);
	var second=str.substr(17,2);
	var date = new Date(year, month , day,hour,minute,second);
	return date;
}
function getToday() {
	return formatDate(now)
}

function getNow() {
	return formatNow(now)
}

function getYestoday() {
	var myDate = new Date(nowYear, nowMonth, nowDay - 1)
	return formatDate(myDate)
}

function getThedaybeforeyestoday() {
	var myDate = new Date(nowYear, nowMonth, nowDay - 2)
	return formatDate(myDate)
}
// 获得本周的开始日期
function getWeekStartDate() {
	var weekStartDate = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek + 1)
	return formatDate(weekStartDate)
}
// 获得本周的结束日期
function getWeekEndDate() {
	var weekEndDate = new Date(nowYear, nowMonth, nowDay + (7 - nowDayOfWeek))
	return formatDate(weekEndDate)
}
// 获得上周的开始日期
function getLastWeekStartDate() {
	var weekStartDate = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek - 7)
	return formatDate(weekStartDate)
}
// 获得上周的结束日期
function getLastWeekEndDate() {
	var weekEndDate = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek - 1)
	return formatDate(weekEndDate)
}
// 获得本月的开始日期
function getMonthStartDate() {
	var monthStartDate = new Date(nowYear, nowMonth, 1)
	return formatDate(monthStartDate)
}
// 获得本月的结束日期
function getMonthEndDate() {
	var monthEndDate = new Date(nowYear, nowMonth, getMonthDays(nowMonth))
	return formatDate(monthEndDate)
}
// 获得上月开始时间
function getLastMonthStartDate() {
	var lastMonthStartDate = new Date(nowYear, lastMonth, 1)
	return formatDate(lastMonthStartDate)
}
// 获得上月结束时间
function getLastMonthEndDate() {
	var lastMonthEndDate = new Date(nowYear, lastMonth, getMonthDays(lastMonth))
	return formatDate(lastMonthEndDate)
}
// 获得本季度的开始日期
function getQuarterStartDate() {
	var quarterStartDate = new Date(nowYear, getQuarterStartMonth(), 1)
	return formatDate(quarterStartDate)
}
// 或的本季度的结束日期
function getQuarterEndDate() {
	var quarterEndMonth = getQuarterStartMonth() + 2
	var quarterStartDate = new Date(nowYear, quarterEndMonth,
		getMonthDays(quarterEndMonth))
	return formatDate(quarterStartDate)
}
// 获得本年开始时间
function getYearStartDate() {
	var yearStartDate = new Date(nowYear, 0, 1)
	return formatDate(yearStartDate)
}
// 获得本年结束时间
function getYearEndDate() {
	var yearEndDate = new Date(nowYear, 11, 31)
	return formatDate(yearEndDate)
}

function checkAmount(dPrice) {
	for (var i = 0; i < dPrice.length; i++) {
		if (isNaN(parseInt(dPrice.charAt(i))) && dPrice.charAt(i) !== '.' && dPrice.charAt(i) !== ',') {
			return false
		}
	}
	if (dPrice.indexOf('.') !== dPrice.lastIndexOf('.')) {
		return false
	}
	var re = /,/g
	var amt1 = dPrice.replace(re, '')
	var amt2 = parseFloat(amt1)
	if (amt2 <= 0) {
		return false
	} else {
		if (amt1.indexOf('.') !== -1) {
			var str = amt1.substr(amt1.indexOf('.') + 1)
			if (str.length > 2) {
				return false
			}
		}
		if (amt1.charAt(0) === '0' && amt1.indexOf('.') !== 1) {
			return false
		}
		var temp = (amt1.indexOf('.') !== -1) ? amt1.substring(0, amt1.indexOf('.')) : amt1
		if (temp.length > 10) {
			return false
		}
	}
	return true
}
// 循环出父节点
export function toTreeData(data, id, pid, name) {
	// 建立个树形结构,需要定义个最顶层的父节点，pId是1
	const parent = []
	for (let i = 0; i < data.length; i++) {
		if (data[i][pid] == '0' || data[i][pid] == 'wd0') {
			const obj = {
				label: data[i][name],
				id: data[i][id],
				value: data[i][id],
				children: []
			}
			parent.push(obj) // 数组加数组值
		}
	}
	children(parent)

	// 调用子节点方法,参数为父节点的数组
	function children(parent) {
		if (parent !== undefined && data.length !== 0) {
			for (let i = 0; i < parent.length; i++) {
				for (let j = 0; j < data.length; j++) {
					if (parent[i].id == data[j][pid]) {
						const obj = {
							label: data[j][name],
							id: data[j][id],
							value: data[j][id]
						}
						if (parent[i].children === undefined) {
							parent[i].children = []
						}
						parent[i].children.push(obj)
					}
				}
				if (parent[i].children !== undefined) {
					children(parent[i].children)
				}
			}
		}
	}
	return parent
}

function getDateTime(type) {
	const date = new Date()
	let year = date.getFullYear()
	let month = date.getMonth() + 1
	let day = date.getDate()
	let h = date.getHours() // 获取当前小时数(0-23)
	let m = date.getMinutes() // 获取当前分钟数(0-59)
	let s = date.getSeconds()
	if (type === 'start') {
		year = year - 20
	}
	if (type === 'start1') {
		year = year - 1
	} else if (type === 'end') {
		year = year + 2
	}
	month = month > 9 ? month : '0' + month
	day = day > 9 ? day : '0' + day
	h = h > 9 ? h : '0' + h
	m = m > 9 ? m : '0' + m
	s = s > 9 ? s : '0' + s

	return `${year}-${month}-${day} ${h}:${m}:${s}`
}

function getDate(type) {
	const date = new Date()
	let year = date.getFullYear()
	let month = date.getMonth() + 1
	let day = date.getDate()

	if (type === 'start') {
		year = year - 20
	}
	if (type === 'start1') {
		year = year - 1
	} else if (type === 'end') {
		year = year + 2
	}
	month = month > 9 ? month : '0' + month
	day = day > 9 ? day : '0' + day
	return `${year}-${month}-${day}`
}

function getTime() {
	const date = new Date()
	let h = date.getHours() // 获取当前小时数(0-23)
	let m = date.getMinutes() // 获取当前分钟数(0-59)
	let s = date.getSeconds()
	h = h > 9 ? h : '0' + h
	m = m > 9 ? m : '0' + m
	s = s > 9 ? s : '0' + s
	return `${h}:${m}:${s}`
}

function getDateMonthEnd(year2, month2) {
	var date = new Date(parseInt(year2), parseInt(month2), 0);
	// console.log(date);
	// if (month2==12){
	// 	date=new Date(year2+1,1,0)
	// }else{
	// 	date=new Date(year2,month2+1,0);
	// }
	var year = date.getFullYear();
	var month = date.getMonth() + 1;
	var day = date.getDate();
	month = month > 9 ? month : '0' + month;
	day = day > 9 ? day : '0' + day;
	return `${year}-${month}-${day}`;
}

function datediffmi(sdate, edate) {
	var time = sdate.replace(/-/g, ':').replace(' ', ':');
	time = time.split(':');
	var date1 = new Date(time[0], (time[1] - 1), time[2], time[3], time[4], time[5]);
	time = edate.replace(/-/g, ':').replace(' ', ':');
	time = time.split(':');
	var date2 = new Date(time[0], (time[1] - 1), time[2], time[3], time[4], time[5]);
	const s1 = date1.getTime();
	const s2 = date2.getTime();
	const Minute2 = Number((s2 - s1) / 60000);
	return Minute2;
}

function datediffday(sdate, edate) {
	var time = sdate.replace(/-/g, ':').replace(' ', ':');
	time = time.split(':');
	var date1 = new Date(time[0], (time[1] - 1), time[2]);
	time = edate.replace(/-/g, ':').replace(' ', ':');
	time = time.split(':');
	var date2 = new Date(time[0], (time[1] - 1), time[2]);
	const s1 = date1.getTime();
	const s2 = date2.getTime();
	const day = Math.floor((s2 - s1) / (60000 * 60 * 24));
	return day;
}

function datediffhour(sdate, edate) {
	var time = sdate.replace(/-/g, ':').replace(' ', ':');
	time = time.split(':');
	var date1 = new Date(time[0], (time[1] - 1), time[2], time[3], time[4], time[5]);
	time = edate.replace(/-/g, ':').replace(' ', ':');
	time = time.split(':');
	var date2 = new Date(time[0], (time[1] - 1), time[2], time[3], time[4], time[5]);
	const s1 = date1.getTime();
	const s2 = date2.getTime();
	const day = Number((s2 - s1) / (60000 * 60));
	return day;
}

function datediff(sdate, edate) {
	var time = sdate.replace(/-/g, ':').replace(' ', ':');
	time = time.split(':');
	var date1 = new Date(time[0], (time[1] - 1), time[2], time[3], time[4], time[5]);
	time = edate.replace(/-/g, ':').replace(' ', ':');
	time = time.split(':');
	var date2 = new Date(time[0], (time[1] - 1), time[2], time[3], time[4], time[5]);
	const s1 = date1.getTime();
	const s2 = date2.getTime();
	const s3 = s2 - s1;
	const day = Math.floor(s3 / (24 * 3600 * 1000));
	const s4 = s3 % (24 * 3600 * 1000);
	const hour = Math.floor(s4 / (3600 * 1000))
	const minute = Math.floor(s4 % (3600 * 1000) / (60 * 1000));
	if (day < 0) {
		return '已到期'
	} else {
		return day + '天' + hour + '小时' + minute + '分';
	}
}

function wdbase64(str) {
	var wordArray = CryptoJS.enc.Utf8.parse(str)
	var base64 = CryptoJS.enc.Base64.stringify(wordArray)
	return base64
}

function wddebase64(str) {
	var parsedWordArray = CryptoJS.enc.Base64.parse(str)
	var parsedStr = parsedWordArray.toString(CryptoJS.enc.Utf8)
	return parsedStr
}

function wdmd5(str) {
	return CryptoJS.MD5(str).toString()
}

function numberFixed(amount, point = 2) {
	if (amount === undefined || amount == '') {
		return 0
	}
	var aa = parseFloat(amount).toFixed(point)
	return aa
}

function numberFixedy(amount, point = 2) {
	if (amount === undefined || amount == '') {
		return 0
	}
	var aa = parseFloat(amount).toFixed(point)
	var bb = aa.substring(0, aa.indexOf('.'))
	return bb
}

function numberFixedjf(amount, point = 2) {
	if (amount === undefined || amount == '') {
		return 0
	}
	var aa = parseFloat(amount).toFixed(point)
	var bb = aa.substring(aa.indexOf('.'))
	return bb
}
function ratevalue(amount) {
	
	if (amount === undefined || amount == '') {
		return 0
	}
	var aa = parseInt(amount)
	return aa
}
function wdnonestr(len = 32) {
	len = len || 32;
	var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'; /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
	var maxPos = $chars.length;
	var pwd = '';
	for (let i = 0; i < len; i++) {
		pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
	}
	return pwd;
}

function replaceAll(s1, s2, s3) {
	if (isEmpty(s1)){
		return s1;
	}
	var r = new RegExp(s2.replace(/([\\])/g, "\\$1"), "ig");
	// \{\}\^\$\+\-\*\?\.\"\'\|\/
	return s1.replace(r, s3);
}
function isEmpty(v) {
    switch (typeof v) {
    case 'undefined':
        return true;
    case 'string':
        if (v.replace(/(^[ \t\n\r]*)|([ \t\n\r]*$)/g, '').length == 0) return true;
        break;
    case 'boolean':
        if (!v) return true;
        break;
    case 'number':
        if (0 === v || isNaN(v)) return true;
        break;
    case 'object':
        if (null === v || v.length === 0) return true;
        for (var i in v) {
            return false;
        }
        return true;
    }
    return false;
}
export default {
	formatNow,
	getNow,
	getToday,
	getYestoday,
	getThedaybeforeyestoday,
	getWeekStartDate,
	getWeekEndDate,
	getMonthStartDate,
	getMonthEndDate,
	getQuarterStartDate,
	getQuarterEndDate,
	getYearStartDate,
	getYearEndDate,
	getLastWeekStartDate,
	getLastWeekEndDate,
	getLastMonthStartDate,
	getLastMonthEndDate,
	checkAmount,
	toTreeData,
	getDateTime,
	getDate,
	getTime,
	wdbase64,
	wddebase64,
	wdmd5,
	numberFixed,
	numberFixedy,
	numberFixedjf,
	wdnonestr,
	replaceAll,
	datediffmi,
	datediffday,
	datediff,
	datediffhour,
	getDateMonthEnd,
	strtodate,
	isEmpty,
	ratevalue
}
